import React from "react";
import RegisterContainer from "./RegisterContainer";

export default () => (
  <RegisterContainer />
);
